var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"antv-chart-mini"},[_c('div',{staticClass:"chart-wrapper",style:({ height: 46 })},[_c('v-chart',{attrs:{"force-fit":true,"data":_vm.dataChart,"scale":_vm.scale,"padding":[36, 5, 18, 5]}},[_c('v-tooltip'),_c('v-pie',{attrs:{"position":_vm.position}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }